"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isStorageSupported = exports.isSessionStorageSupported = exports.isLocalStorageSupported = void 0;
var _string = require("./../type-checks/string");
var _uuid = require("uuid");
const isStorageSupported = storageType => {
  let result = false,
    uuid = `test_${(0, _uuid.v4)()}`,
    value = null;
  if ((0, _string.isStringOfLength)(storageType) && (storageType === "localStorage" || storageType === "sessionStorage")) {
    try {
      window[storageType].setItem(uuid, "true");
      value = window[storageType].getItem(uuid);
      if (value === "true") {
        window[storageType].removeItem(uuid);
        result = true;
      }
    } catch (e) {
      console.error(`${e.name}: ${e.message}`);
      result = false;
    }
  }
  return result;
};
exports.isStorageSupported = isStorageSupported;
const isLocalStorageSupported = exports.isLocalStorageSupported = (() => isStorageSupported("localStorage"))();
const isSessionStorageSupported = exports.isSessionStorageSupported = (() => isStorageSupported("sessionStorage"))();